import api from '../../config/APIConfig'

const { iAxios, apiUri } = api
const baseUrl = `${apiUri}/`

export const IDVActions = {
    preguntasCI
    ,ValidarCI
    ,respuestasCI
}
// function ValidarCI(personaci) {
//     //return iAxios.get(`${baseUrl}ValidarCI?Token=`+token+'&rut='+rut+'&numSerie='+numSerie)
//     return iAxios.post(`${baseUrl}ValidarCIPost`,personaci)
// }
function ValidarCI({ token, run, numSerie }) {
    const rutFormateado = run.replace(/\./g, '');
    //GET - https://testingback.firmadox.cl/api/ValidarCI?token=3c2c5fac31df48ebbc4a3cf86433a358d361c7a9f06935b0e36ad01c8f008901&rut=10980833-4&numSerie=518090643
    return iAxios.get(`${baseUrl}ValidarCI?Token=${token}&rut=${rutFormateado}&numSerie=${numSerie}`);
}
function preguntasCI(token) {
    return iAxios.get(`${baseUrl}preguntasCI?Token=`+token)
}
function respuestasCI(Respuesta) {
    return iAxios.post(`${baseUrl}respuestasCI`,Respuesta)
}
